<template>

    <nav :class="{open:open}">
        <span class="nav_toggle" v-on:click="open = !open"></span>
      <ul>
        <li class="home"><router-link :to="{ name: 'home'}"><img src="../assets/icons/home.svg" />Home</router-link></li>
        <li class="sites">
          <router-link :to="{ name: 'site'}"><img src="../assets/icons/sites.svg" />Switch Sites</router-link><br/>
          <span v-if="account.name !== undefined && unit.name !== undefined">You're currently on<br></span><span class="bold">{{account.name}} <br> {{unit.name}}</span>
        </li>
        <li class="redemptions" v-if="userCanViewRedemptions()"><router-link :to="{ name: 'redemptions'}"><img src="../assets/icons/redemptions.svg" />Redemptions</router-link></li>
        <!--<li class="toggle"><a href="https://mytoggle.io/dashboard">Toggle Platform</a></li>-->
        <li class="logout"><a v-on:click="$store.dispatch('logout')" href="#"><img src="../assets/icons/logout.svg" />Logout</a></li>
      </ul>
    </nav>

</template>

<script>
export default {
  name: 'Navigation',
  data : function(){       
      return {
        open:false
      };
  },
  watch:{
    $route:function(){
        this.open = false;
    }
  },
  computed: {

      unit()
      {
          return this.$store.getters.getUnit;
      },
      account()
      {
          return this.$store.getters.getAccount;
      },
  
  },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  @import "../assets/scss/variables";
  
  nav{

    button{
      background: transparent;
      border:0;
    }

    width:$nav-width;
    margin-left:-$nav-width;
    height:100%;
    position: fixed;
    z-index: 1;
    top:0;
    color: $nav-font-color;
    background-color:$input-background-color;
    box-sizing: border-box;
    transition: background-color 0.4s, margin-left 0.4s;
    margin-top:0;
    
    &.open{
      margin-left: 0;
      background-color:$nav-background-color;
      span.nav_toggle{
        background-image: url('../assets/icons/nav_hide.svg');
        background-color: #FFFFFF;
      }
    }
    ul{
      height:100%;
      padding:20px 20px 40px 40px;
      overflow-y: scroll;
      display: block;
      list-style: none;
      margin:0;
      li{
        overflow: auto;
        text-align: left;
        position: relative;
        padding: 25px 0;
        padding-left:50px;
        img{
          height:25px;
          margin-left:-50px;
          position: absolute;
          margin-top:-3px;
        }

        /*&::before{
          height: 2rem;
          width: 2rem;
          position: absolute;
          margin-left:-3rem;
          margin-top:-0.2rem;
        }*/
        &.home{
          img{
            margin-left:-50px;
          }
        }
        &.sites{
          img{
            margin-left:-50px;
          }
        }
        &.redemptions{
          img{
            margin-left:-45px;
          }
        }
        &.toggle{
          img{
            margin-left:-50px;
          }
        }
        &.logout{
          img{
            height:20px;
            margin-top:0;
            margin-left:-45px;
          }
        }
        a, button
        {
          -webkit-appearance: none;
          -moz-appearance: none;

          text-decoration: none;
          color:$nav-font-color !important;
        }
        span, button{
          float:left;
          clear:both;
          display: block;
          font-size: 13px;
          font-family: 'Lato', sans-serif;
          &.bold{            
            font-weight: 700;

          }
        }
      }
    }

    span.nav_toggle{
      cursor: pointer;
      position: absolute;
      right:-50px;
      color:black;
      width:50px;
      height:40px;
      top:10px;
      background-image: url('../assets/icons/nav_icon.svg');
      background-repeat: no-repeat;
      background-size: auto 20px;
      background-position: right 15px top 50%;
      border-radius: 0px 15px 15px 0px;
      padding:5px;
      background-color:$input-background-color;
      box-sizing: border-box;
      transition: background-color 0.5s;
    }
  }
  @media only screen and (max-width: 550px) {
      nav{
        &.open{
        width: 268px;
        }
      }
    }
</style>
